<template>
  <PrioritaetWidget
    v-if="params.value !== '(Select All)'"
    :prioritaet="params.value"
    :class="{ 'kachel-badge-sm': params.isFilterRenderer }"
  ></PrioritaetWidget>
  <div v-else>(Select All)</div>
</template>

<script>
import PrioritaetWidget from '@/components/common/prioritaet-widget.vue';

export default {
  components: { PrioritaetWidget },
};
</script>
